import React from "react";
import {styled} from '@mui/material/styles';
import {observer} from "mobx-react-lite";
import {Autocomplete, createFilterOptions, Popover, TextField} from "@mui/material";
import {CategorizationViewOnlyComponent} from "./CategorizationViewOnlyComponent";
import type {TaxonomyCategory} from "../../stores/TaxonomyCategoryProvider";
import type {CategoryMenuController} from "../../pages/categorization/context/CategoryMenuController";
import {useStores} from "../../stores";

const classes = {
    typography: `PartReCategorizationHandler-typography`,
    popoverContent: `PartReCategorizationHandler-popoverContent`,
    option: `PartReCategorizationHandler-option`
};

const StyledPopover = styled(Popover)(({theme}) => ({
    [`& .${classes.typography}`]: {
        padding: theme.spacing(2),
    },

    [`& .${classes.popoverContent}`]: {
        margin: 10,
        background: 'transparent',
    },

    [`& .${classes.option}`]: {
        fontSize: 15,
        '& > span': {
            marginRight: 10,
            fontSize: 18,
        },
    }
}));


const filterOptions = createFilterOptions<TaxonomyCategory>({
    matchFrom: 'any',
    stringify: option => option.search,
});

type Props = {
    controller?: CategoryMenuController
    cmpId?: string
    label?: string
}
export const PartReCategorizationHandler: React.FC<Props> = observer(({controller, cmpId, label}) => {
    const {p} = useStores();
    if (!controller || !controller.taxonomy) {
        return <></>;
    }
    const autoId = cmpId ?? `part-recat-component`;
    const popId = controller.isOpen ? autoId + '-popover' : undefined;
    label = label || 'Search for a category';
    const showCategoryId = Boolean(p.p.showCategoryId);
    return <StyledPopover
        id={popId}
        open={controller.isOpen}
        anchorEl={controller.anchor}
        onClose={() => controller.close()}
        anchorOrigin={controller.anchorOrigin}
        transformOrigin={controller.transformOrigin}
        disableScrollLock={controller.disableScrollLock}
    >
        <Autocomplete
            id={autoId}
            style={{width: p.p.deepTaxonomy ? 1400 : 800}}
            options={controller.taxonomy}
            className={classes.popoverContent}
            classes={{
                option: classes.option,
            }}
            filterOptions={filterOptions}
            autoHighlight
            getOptionLabel={(option) => option.label} // Dennis: What does this do?
            renderOption={(props, option) =>
                <li {...props} key={props.key}>
                    <CategorizationViewOnlyComponent category={option} showCategoryId={showCategoryId}
                                                     colWidth={typeof window !== 'undefined' ? Math.min(800, window.innerWidth) : 800}/>
                </li>
            }
            onChange={(_, value: TaxonomyCategory | null) => {
                if (value) {
                    controller.onSelectCategory(value)
                }
            }}
            renderInput={(params) =>
                <TextField
                    {...params}
                    label={label}
                    variant="outlined"
                    autoFocus
                    inputProps={{
                        ...params.inputProps,
                        // autoComplete: 'new-password', // disable autocomplete and autofill
                    }}
                />
            }
        />
    </StyledPopover>
})
